module.exports = __webpack_public_path__ + "static/rarf-logo-cd46d20419a259479803b8c6514220d7.png";